





























































































































































































import { defineComponent, computed, ref, Ref, toRefs, watch, getCurrentInstance } from '@vue/composition-api';
import { DialogPlugin, DialogInstance } from 'tdesign-vue';
import { RefreshIcon, SearchIcon, HelpCircleIcon, EditIcon } from 'tdesign-icons-vue';
import AddMembers, { SubmitEvent } from '@/renderer/components/dialog/AddTransfer/AddMember/index.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import { phoneCompose, getNameTipsDetail } from '@/renderer/scripts/utils/tools/index';
import { userRole } from '@/renderer/scripts/utils/ConstantConfig/ConstantI18NConfig';
import ipc from '@/renderer/scripts/utils/ipc';
import { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import { formatError } from '@/renderer/scripts/utils/errorCode/index';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';
import fileRoleConfig from './fileRoleConfig.vue';
import teamRoleConfig from './teamRoleConfig.vue';
import listHandler from '../compositions/listHandler';

export default defineComponent({
  components: {
    RefreshIcon,
    SearchIcon,
    HelpCircleIcon,
    EditIcon,
    AddMembers,
    fileRoleConfig,
    teamRoleConfig,
  },
  props: {
    rootId: {
      type: Number,
      default: -1,
    },
    teamId: {
      type: Number,
      default: -1,
    },
    isRoot: {
      type: Boolean,
      default: true,
    },
    teamDefaultRoleId: {
      type: Number,
    },
    teamNoSpace: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = vm.$store;
    const currentUser = computed(() => store.getters.userBaseInfo);
    const { isRoot: currentIsRoot, rootId, teamId, teamNoSpace } = toRefs(props);
    const {
      loading,
      columns,
      tableData,
      sort,
      rolesMap,
      initData,
      queryMember,
      searchMember,
      handleSelectRows,
      onPageSizeChange,
      onCurrentChange,
      addTeamMember,
      removeMember,
      refresh,
      sortChange,
      switchSort,
      editFileRole,
      addTeamAdmin,
      deleteTeamAdmin,
    } = listHandler({ rootId, teamId, teamNoSpace });

    const addUserShow = ref(false);
    // const { addUserShow, openShareDialog } = dialogHandler(rootId, teamId);

    const editFileRoleShow = ref(false);
    const editTeamRoleShow = ref(false);
    const editingUsers: Ref<CoFile.TeamMember[]> = ref([]);
    const methods = {
      getFilePrivilegeName(row: SMH.TeamMemberItemData) {
        // 系管、超管默认操作者
        if (['superAdmin', 'admin'].includes(row.role)) {
          return i18n_t('操作者');
        }
        // 团队管理员默认操作者
        if (row.teamRole === 'teamAdmin') {
          return i18n_t('操作者');
        }
        return rolesMap.value.get(
          (row.teamRoleId as unknown as number) || (props.teamDefaultRoleId as unknown as number),
        );
      },
      // 删除用户
      async removeUser(row: SMH.UserBaseInfo) {
        const dialog: DialogInstance = CustomDialog.confirm({
          theme: 'warning',
          header: i18n_t('确定要把"{slot1}"从该团队中移除吗？', {
            slot1: row.nickname,
          }),
          body: i18n_t('移除后，该用户在团队空间中创建的文件不会被删除'),
          async onConfirm() {
            if (dialog.hide) {
              dialog.hide();
            }
            await removeMember([row.id]);
            queryMember();
            ipc.emit(ipc.RENDERER_EVENTS_MAP.TEAM_LIST_REFRESH);
          },
        });
      },
      // 批量删除用户
      async removeUsers() {
        const dialog: DialogInstance = CustomDialog.confirm({
          theme: 'warning',
          header: i18n_t('确定要把所选{slot1}个成员从该团队中移除吗？', {
            slot1: tableData.selectedList.length,
          }),
          body: i18n_t('移除后，该用户在团队空间中创建的文件不会被删除'),
          async onConfirm() {
            if (dialog.hide) {
              dialog.hide();
            }
            const userIds = tableData.selectedList.map((item: any) => item.id);
            await removeMember(userIds);
            queryMember();
            ipc.emit(ipc.RENDERER_EVENTS_MAP.TEAM_LIST_REFRESH);
          },
        });
      },
      // 添加用户
      async addUserFn(params: SubmitEvent) {
        const { changed, deleted, added } = params;
        const userIdList: number[] = [];
        const authorizeTo: CoFile.DirAuthorize[] = [];
        let deletedUserIds: number[] = [];
        if (deleted) {
          deletedUserIds = deleted.map(item => item.userId as number);
        }
        [...(changed || []), ...(added || [])].forEach(item => {
          userIdList.push(item.userId as number);
          authorizeTo.push({
            userId: item.userId,
            name: item.name,
            roleId: +item.roleId as number,
          });
        });
        const userIds = userIdList;
        try {
          tips.loading(i18n_t('正在更新...'));
          // 删除后再进行追加（否则追加的内容会被删除的接口删除掉）
          deletedUserIds.length > 0 && (await removeMember(deletedUserIds, false));
          userIds.length > 0 && (await addTeamMember(userIds, authorizeTo));
          tips.success(i18n_t('更新成功'));
          addUserShow.value = false;
          queryMember();
          ipc.emit(ipc.RENDERER_EVENTS_MAP.TEAM_LIST_REFRESH);
        } catch (err: any) {
          const msg = [i18n_t('更新成员失败')];
          msg.push(formatError(err));
          tips.error(msg.filter(s => s).join(','));
          addUserShow.value = true;
        }
      },
      // 打开详情弹窗
      openHelp() {
        context.emit('open-help');
      },
      // 行内点击编辑团队权限（暂不支持批量修改，格式先保留数组，方便以后拓展）
      showEditTeamRole(user: SMH.TeamMemberItemData) {
        const { nickname, id, teamRole } = user;
        editingUsers.value = [
          {
            userId: id,
            name: nickname,
            teamRole: (teamRole as string) || 'user',
          },
        ];
        editTeamRoleShow.value = true;
      },
      // 行内点击编辑文件权限
      showEditFileRole(user?: SMH.TeamMemberItemData) {
        if (!user) {
          editingUsers.value = tableData.selectedList
            .filter(item => !item.fileRoleDisabled)
            .map(item => ({
              userId: item.id,
              name: item.nickname,
              teamRoleId: item.teamRoleId as string,
            }));
        } else {
          const { nickname, id, teamRoleId } = user;
          editingUsers.value = [
            {
              userId: id,
              name: nickname,
              teamRoleId: teamRoleId as string,
            },
          ];
        }
        editFileRoleShow.value = true;
      },
      // 确认修改文件权限
      async confirmEditFileRole(authority: CoFile.DirAuthorize[]) {
        const editSuccessful = await editFileRole(authority);
        editFileRoleShow.value = false;
        if (editSuccessful) {
          queryMember();
          ipc.emit(ipc.RENDERER_EVENTS_MAP.TEAM_LIST_REFRESH);
        }
      },
      // 确认修改团队管理员权限
      async confirmEditTeamRole({ teamRole, userIds }: { teamRole: 'user' | 'teamAdmin'; userIds: string }) {
        const editSuccessful = teamRole === 'user' ? await deleteTeamAdmin(userIds) : await addTeamAdmin(userIds);
        editTeamRoleShow.value = false;
        // 当设为团队管理员时，主动把该用户权限设为操作者
        if (teamRole === 'teamAdmin') {
          const operateRoleId = store.getters.operatorRole.id;
          const authority: SMH.DirAuthorize[] = editingUsers.value.map(item => ({
            userId: item.userId,
            name: item.name,
            roleId: operateRoleId,
          }));
          await editFileRole(authority);
        }
        if (editSuccessful) {
          queryMember();
          ipc.emit(ipc.RENDERER_EVENTS_MAP.TEAM_LIST_REFRESH);
        }
      },
    };
    watch(
      () => props.teamId,
      () => {
        initData();
        if (props.teamId === -1) return;
        queryMember();
      },
    );
    const iSshowEditFileRoleButton = computed(() => {
      return tableData.selectedList.filter(item => !item.fileRoleDisabled).length > 0;
    });
    return {
      loading,
      columns,
      ...toRefs(tableData),
      sort,
      userRole,
      currentUser,
      currentIsRoot,
      addUserShow,
      rolesMap,
      editFileRoleShow,
      editTeamRoleShow,
      editingUsers,
      handleSelectRows,
      onPageSizeChange,
      onCurrentChange,
      initData,
      queryMember,
      searchMember,
      refresh,
      sortChange,
      switchSort,
      ...methods,
      phoneCompose,
      getNameTipsDetail,
      iSshowEditFileRoleButton,
    };
  },
});
